// @file Store that handles field_test experiments
import { Module } from 'vuex'

interface ExperimentsState {
  isLoaded: boolean
  planVisual: string
}

const blankExperimentsState = (): ExperimentsState => ({
  isLoaded: false,
  planVisual: '',
})

const ExperimentsModule: Module<ExperimentsState, object> = {
  namespaced: true,
  state: blankExperimentsState,
  getters: {
    isLoaded: (state): boolean => !!state.isLoaded,
    isPlanVisualActive: (state): boolean => !!state.planVisual,
    isPlanVisualUsingNewBasicName: (state): boolean =>
      ['platinum_neon_in_pink_grey', 'platinum_neon_in_green_pink'].includes(state.planVisual), // neon if true; basic otherwise
    isPlanVisualUsingNewProName: (state): boolean =>
      [
        'platinum_neon_in_pink_grey',
        'platinum_neon_in_green_pink',
        'platinum_basic_in_pink_grey',
        'platinum_basic_in_green_pink',
      ].includes(state.planVisual), // platinum if true; pro otherwise
    isPlanVisualUsingNewColors: (state): boolean =>
      ['pro_basic_in_green_pink', 'platinum_neon_in_green_pink', 'platinum_basic_in_green_pink'].includes(
        state.planVisual,
      ), // green pink if true; pink grey otherwise
  },
  mutations: {
    INITIALIZE_PLAN_VISUAL_STATE(state, variant: string): void {
      state.planVisual = variant
    },
    SET_IS_LOADED(state, isLoaded: boolean): void {
      state.isLoaded = isLoaded
    },
  },
  actions: {
    initializeState({ commit }, experiment: { planVisual: string }): void {
      if (experiment && experiment['planVisual']) commit('INITIALIZE_PLAN_VISUAL_STATE', experiment['planVisual'])
      commit('SET_IS_LOADED', true)
    },
  },
}

export default ExperimentsModule
